/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes,extraRequire}
 * tslint:disable
 */
var styles = ["#load[_ngcontent-%COMP%]{width:100%;height:100%;position:fixed;z-index:9999}.mainCard[_ngcontent-%COMP%]{border:1px solid #ddd;margin:0 auto;border-radius:25px;padding:7px 0;width:100%;border-bottom-left-radius:0;border-bottom-right-radius:0}.mainCardHeader[_ngcontent-%COMP%]{padding:10px 15px}.paddLong[_ngcontent-%COMP%]{padding-left:0;padding-right:20px}.marginZero[_ngcontent-%COMP%]{margin:0}.paddingRightZero[_ngcontent-%COMP%]{padding-right:0}"];
export { styles as styles };

